"use client";

import { CalendarDays, Columns3, MapIcon, Table2 } from "@/components/icons";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import type { RecordPresentationMode } from "./types";

const PRESENTATION_OPTIONS = {
  table: { label: "Table", icon: Table2 },
  board: { label: "Board", icon: Columns3 },
  calendar: { label: "Calendar", icon: CalendarDays },
  map: { label: "Map", icon: MapIcon },
} satisfies Record<
  RecordPresentationMode,
  { label: string; icon: typeof Table2 }
>;

interface RecordPresentationSwitcherProps {
  modes: RecordPresentationMode[];
  value: RecordPresentationMode;
  onChange: (mode: RecordPresentationMode) => void;
}

export function RecordPresentationSwitcher({
  modes,
  value,
  onChange,
}: RecordPresentationSwitcherProps) {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(nextValue) => {
        if (
          nextValue === "table" ||
          nextValue === "board" ||
          nextValue === "calendar" ||
          nextValue === "map"
        ) {
          onChange(nextValue);
        }
      }}
      variant="outline"
      size="sm"
      aria-label="Presentation mode"
      className="gap-0"
    >
      {modes.map((mode) => {
        const option = PRESENTATION_OPTIONS[mode];
        const Icon = option.icon;
        return (
          <ToggleGroupItem
            key={mode}
            value={mode}
            className="gap-1.5 rounded-none px-2.5 text-xs first:rounded-l-md last:rounded-r-md [&:not(:first-child)]:border-l-0"
          >
            <Icon aria-hidden className="size-3.5" />
            {option.label}
          </ToggleGroupItem>
        );
      })}
    </ToggleGroup>
  );
}
